var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.5,
    r: 15,
    fill: "#F7F6F6",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3273 8.01445C16.1458 8.00195 16.9583 8.00845 17.7703 8.00195C17.7973 9.01745 18.2093 9.93145 18.8648 10.6085L18.8638 10.6075C19.5693 11.243 20.4873 11.655 21.4993 11.725L21.5133 11.726V14.244C20.5573 14.22 19.6583 13.9995 18.8478 13.6205L18.8888 13.6375C18.4968 13.449 18.1653 13.2555 17.8503 13.0395L17.8763 13.0565C17.8703 14.881 17.8823 16.7055 17.8638 18.5235C17.8123 19.45 17.5043 20.295 17.0103 21.0005L17.0203 20.985C16.1943 22.168 14.8563 22.9445 13.3348 22.9905H13.3278C13.2663 22.9935 13.1938 22.995 13.1208 22.995C12.2558 22.995 11.4473 22.754 10.7583 22.3355L10.7783 22.347C9.52427 21.5925 8.65927 20.3015 8.49927 18.8L8.49727 18.7795C8.48477 18.467 8.47877 18.1545 8.49127 17.8485C8.73627 15.459 10.7383 13.6105 13.1718 13.6105C13.4453 13.6105 13.7133 13.634 13.9738 13.6785L13.9458 13.6745C13.9583 14.599 13.9208 15.524 13.9208 16.4485C13.7093 16.372 13.4653 16.3275 13.2108 16.3275C12.2768 16.3275 11.4823 16.9245 11.1883 17.758L11.1838 17.773C11.1173 17.9865 11.0788 18.232 11.0788 18.486C11.0788 18.589 11.0853 18.691 11.0973 18.791L11.0963 18.779C11.2623 19.802 12.1393 20.574 13.1968 20.574C13.2273 20.574 13.2573 20.5735 13.2873 20.572H13.2828C14.0143 20.55 14.6493 20.1565 15.0083 19.575L15.0133 19.566C15.1468 19.38 15.2383 19.155 15.2688 18.9105L15.2693 18.9035C15.3318 17.785 15.3068 16.673 15.3128 15.5545C15.3188 13.0365 15.3068 10.5245 15.3253 8.01295L15.3273 8.01445Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.6b2adc3a.svg";
export { ForwardRef as ReactComponent };